/**
 * Numeric rounding for canvas state. One precision per concern so that
 * any path that writes the same value (drag, keyboard nudge, toolbar,
 * cascade refit) produces identical numbers in the store.
 *
 * - `roundCoord` — positions, angles, sizes (one decimal).
 * - `roundScale` — scale factors (three decimals; finer because a
 *    rounding error is multiplied by every dimension on render).
 */
export const roundCoord = (n: number): number => Math.round(n * 10) / 10;
export const roundScale = (n: number): number => Math.round(n * 1000) / 1000;
